/* import __COLOCATED_TEMPLATE__ from './sh-switch.hbs'; */
import Component from '@ember/component';
import { observer } from '@ember/object';

export default Component.extend({
    classNames: ['sh-switch'],

    /***********************
     * Passable Properties *
     ***********************/
    checked: null,
    disabled: false,

    /**
    * Custom text to display when switch is 'activated'
    *
    * Passed in from caller
    * @type {string}
    */
    customYesText: '',

    /**
    * Custom text to display when switch is 'deactivated'
    *
    * Passed in from caller
    * @type {string}
    */
    customNoText: '',

    /**
     * If this function is defined, it will be called before we update the switch.  You
     * would use this if you'd like to do some prerequisite verification before actually
     * allowing the user to switch the value.
     *
     * onSuccess: switch is updated and checked switch value is propagated
     * onFailure: switch returns to previous state
     *
     * Passed in from parent.
     *
     * @type {Function}
     * @returns {Promise}
     */
    onBeforeUpdate: undefined,

    /**
     * This will be activated when the user fails the onBeforeUpdate check.  This will ensure
     * we don't continuously send actions out when we put the checked value back to what
     * it was previously.
     *
     * @type {boolean}
     */
    isFailedUpdatePrereqCheckMutex : false,

    checkedDidChange: observer('checked', function () {
        const isFailedMutex = this.isFailedUpdatePrereqCheckMutex;
        if (isFailedMutex) {
          //this change is from putting the checkbox back to the previous state.  Clear the mutex and return.
          this.set('isFailedUpdatePrereqCheckMutex', false);
          return;
        }

        const onBeforeUpdate = this.onBeforeUpdate;
        if (onBeforeUpdate) {
          //We have a validation check before we can allow the switch.
          onBeforeUpdate().then(() => {
              const val = !!this.checked;
              this.action({checked: val}, this.resetSwitch.bind(this));
          }).catch(() =>  {
            //user failed the prerequisite check.  Set mutex and put back to previous value.
            this.set('isFailedUpdatePrereqCheckMutex', true);
            this.set('checked', !this.checked);
          });

          return;
        }

        const val = !!this.checked;
        this.action({checked: val});
    }),

    /**
     * This function can be used to reset the switch and is passed as a callback parameter when
     * the swith is activated
     */
    resetSwitch: function() {
        let isFailedMutex = this.get('isFailedUpdatePrereqCheckMutex');
        if (isFailedMutex) {
          return;
        }

        this.set('isFailedUpdatePrereqCheckMutex', true);
        this.set('checked', !this.get('checked'));
      }
});
